import { IOrders, IOrderStatusChanged } from "../models/IOrders";
import { IOrderStatusList } from "../models/IOrderStatusList";

// Sunucudaki MutfacikApiSS.Domain.Order.OrderStatusFlow ile birebir aynı geçiş tablosu.
// Akış tek yönlüdür; iptal yalnız "Siparişinizi Aldık" ve "Hazırlanıyor" aşamalarında mümkündür.

export const ORDER_STATUS_ID = {
  received: "21238beb-3a97-420d-8fad-626166db1b1e",
  preparing: "700924e1-a720-4dbe-8374-6ae56adc4346",
  onTheWay: "840e3442-8a36-4404-8e4b-f6d1fafbbf3b",
  delivered: "55b08d65-d81a-4712-8332-8e59e8340940",
  cancelled: "950565f2-baa3-4977-bef8-8e1dc5962123",
} as const;

const ALLOWED: Record<string, string[]> = {
  [ORDER_STATUS_ID.received]: [ORDER_STATUS_ID.preparing, ORDER_STATUS_ID.cancelled],
  [ORDER_STATUS_ID.preparing]: [ORDER_STATUS_ID.onTheWay, ORDER_STATUS_ID.cancelled],
  [ORDER_STATUS_ID.onTheWay]: [ORDER_STATUS_ID.delivered],
  [ORDER_STATUS_ID.delivered]: [],
  [ORDER_STATUS_ID.cancelled]: [],
};

/**
 * Siparişin şu anki durumundan hedef duruma geçilebilir mi. Aynı duruma "geçiş" sunucuda
 * hata vermese de hiçbir şey değiştirmediği için burada izin verilmez (buton kapalı görünür).
 */
export function canTransitionOrder(currentId?: string | null, nextId?: string | null): boolean {
  if (!currentId || !nextId) return false;
  const current = currentId.toLowerCase();
  const next = nextId.toLowerCase();
  if (current === next) return false;
  return ALLOWED[current]?.includes(next) ?? false;
}

/**
 * Hub'dan gelen OrderStatusChanged'i listedeki satıra uygular; sipariş listede yoksa
 * listeyi olduğu gibi döner. Kabul/iptal bayrakları sunucudaki OrderStatusChange.ApplyAsync
 * ile aynı kuralla güncellenir, böylece satır doğru sütuna geçer.
 */
export function applyOrderStatusChange(
  orders: IOrders | null,
  change: IOrderStatusChanged,
  statusList?: IOrderStatusList,
): IOrders | null {
  if (!orders) return orders;
  const orderId = change.orderId.toLowerCase();
  const statusId = change.orderStatusId.toLowerCase();
  if (!orders.items.some((i) => i.id.toLowerCase() === orderId)) return orders;

  const known = statusList?.find((s) => s.id.toLowerCase() === statusId);
  return {
    ...orders,
    items: orders.items.map((item) => {
      if (item.id.toLowerCase() !== orderId) return item;
      return {
        ...item,
        orderStatusId: known?.id ?? change.orderStatusId,
        orderStatus: known ?? {
          ...item.orderStatus,
          id: change.orderStatusId,
          orderStatusNameTr: change.orderStatusNameTr ?? item.orderStatus?.orderStatusNameTr,
          orderStatusNameEn: change.orderStatusNameEn ?? item.orderStatus?.orderStatusNameEn,
        },
        isOrderEnabled: change.isOrderEnabled,
        isRestourantAccepted:
          statusId === ORDER_STATUS_ID.preparing ? true
          : statusId === ORDER_STATUS_ID.cancelled ? false
          : item.isRestourantAccepted,
      };
    }),
  };
}

/** Sipariş şu an listede mi — değilse olay için listeyi baştan okumak gerekir. */
export function hasOrder(orders: IOrders | null, orderId: string): boolean {
  const id = orderId.toLowerCase();
  return !!orders?.items.some((i) => i.id.toLowerCase() === id);
}
